//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//原料价格维护
const productPrice = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/productPrice/list.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'productPrice',
      name: 'productPrice',
      component: productPrice,
      meta: {
        keepAlive: true,
        title: '原料价格维护',
      },
    },
  ],
};
export default productionRouter;
